import { IKnmErknmFormObject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';

import { IKnmForm } from '../interfaces/IKnmForm';
import { IKnmFormRef } from '../interfaces/IKnmFormRef';

type ObjectsFieldNameType = Extract<keyof IKnmForm, 'objectsErknm' | 'objectsPm'>;

interface IRemoveSubjectErvkObjectsParams {
  formRef: IKnmFormRef | undefined;
  ervkId: string | undefined;
  objectsFieldName: ObjectsFieldNameType;
}

/**
 * Каскадное удаление объектов контроля, добавленных из ЕРВК вместе с контролируемым лицом.
 *
 * Объект контроля хранит в organizationErvkId список ervkId всех КЛ, к которым он привязан:
 * - если объект привязан только к удаляемому КЛ — объект удаляется;
 * - если объект привязан ещё и к другим КЛ — из organizationErvkId "вычёркивается" только ervkId удаляемого КЛ.
 *
 * Возвращает true, если хотя бы один объект был удалён.
 */
export const removeSubjectErvkObjects = ({
  formRef,
  ervkId,
  objectsFieldName,
}: IRemoveSubjectErvkObjectsParams): boolean => {
  const remove = formRef?.current.mutators.remove;

  if (!formRef || !remove || !ervkId) {
    return false;
  }

  const objects: IKnmErknmFormObject[] = formRef.current?.getFieldState(objectsFieldName)?.value || [];
  const indicesToRemove: number[] = [];

  objects.forEach((object, index) => {
    const organizationErvkId = object?.organizationErvkId;

    if (!organizationErvkId?.includes(ervkId)) {
      return;
    }

    if (organizationErvkId.length > 1) {
      formRef.current?.change(
        // @ts-ignore
        `${objectsFieldName}[${index}].organizationErvkId`,
        organizationErvkId.filter(id => id !== ervkId),
      );

      return;
    }

    indicesToRemove.push(index);
  });

  // Удаляем с конца: remove сдвигает индексы оставшихся элементов массива.
  indicesToRemove.reverse().forEach(index => remove(objectsFieldName, index));

  if (indicesToRemove.length) {
    formRef.current?.change('isObjectDeleted', true);
  }

  return indicesToRemove.length > 0;
};
